import { Practitioner } from '@medplum/fhirtypes'
// Doctor lane palette — vivid hues spread evenly around the wheel so consecutive
// doctors (assigned by index) get maximally contrasting, easily distinguishable
// colors. Kept a shade off the status colors (Pending #3B82F6, Confirmed
// #16A34A, No-show #EF4444) so a border never reads as a status; statuses show as
// icons and availability fills are pale pastels, so these solid tones stay clear.
export const DOCTOR_COLORS = [
  '#2563EB', // blue
  '#DC2626', // red
  '#059669', // emerald
  '#9333EA', // purple
  '#F97316', // orange
  '#0891B2', // cyan
  '#DB2777', // pink
  '#CA8A04', // gold
  '#4F46E5', // indigo
  '#0D9488', // teal
  '#92400E', // brown
] as const

export type DoctorColor = (typeof DOCTOR_COLORS)[number]

export type PractitionerWithColor = Practitioner & {
  color: DoctorColor
}
